import type {Response} from 'mappersmith'
import {ModifiError} from '@modifi/errors'

const isResponse = (maybeResponse: any): maybeResponse is Response =>
  typeof maybeResponse === 'object' &&
  typeof maybeResponse.data === 'function' &&
  typeof maybeResponse.status === 'function'

const buildMessage = (message: string, nestedError: Error | Response): string => {
  if (!nestedError) {
    return message
  }
  if (nestedError instanceof Error) {
    return `${message}\n${nestedError.message}`
  }
  if (isResponse(nestedError)) {
    const responseBody = nestedError.data<{errorMessage?: string; httpError?: string}>()
    const responseErrorMessage =
      responseBody.errorMessage || responseBody.httpError || 'Internal Error'
    return `${message}\n${responseErrorMessage}`
  }
  return message
}

export class NestedError extends ModifiError {
  private internalErrorStack: (Error | Response)[] = []

  constructor(message: string, nestedError: Error | Response | NestedError) {
    super(buildMessage(message, nestedError))

    this.internalErrorStack.push(nestedError)
    if (nestedError instanceof NestedError) {
      this.internalErrorStack.push(...nestedError.errorStack)
    }
    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, NestedError)
    }
  }

  public get errorStack(): (Error | Response)[] {
    return this.internalErrorStack
  }
}
